import AuthRedirect from './AuthRedirect';

const AuthRedirectConfig = {
	settings: {
		layout: {}
	},
	routes: [
		{
			path: 'auth-redirect',
			element: <AuthRedirect />
		}
	]
};

export default AuthRedirectConfig;
